import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Sparkles, ClipboardList, User, ShieldCheck } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import DashboardShell from '../../Components/shared/DashboardShell';
import BookAgainPanel from '../../Components/client/BookAgainPanel';
import ClientOrders from '../../Components/client/ClientOrders';
import ClientProfileForm from '../../Components/client/ClientProfileForm';
import ClientKycForm from '../../Components/client/ClientKycForm';

const NAV_ITEMS = [
  { id: 'book', label: 'Book a massage', icon: Sparkles },
  { id: 'orders', label: 'My orders', icon: ClipboardList },
  { id: 'profile', label: 'Profile', icon: User },
  { id: 'kyc', label: 'Identity verification', icon: ShieldCheck }
];

const ClientDashboard = () => {
  const { logout } = useAuth();
  const [searchParams] = useSearchParams();
  const requestedTab = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(
    NAV_ITEMS.some(item => item.id === requestedTab) ? requestedTab : 'book'
  );

  return (
    <DashboardShell
      title="My Dashboard"
      navItems={NAV_ITEMS}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      onLogout={logout}
    >
      {activeTab === 'book' && <BookAgainPanel />}
      {activeTab === 'orders' && <ClientOrders />}
      {activeTab === 'profile' && <ClientProfileForm />}
      {activeTab === 'kyc' && <ClientKycForm />}
    </DashboardShell>
  );
};

export default ClientDashboard;
